import React from 'react';
import Joyride, { CallBackProps } from 'react-joyride';

import { getLocalStorage, setLocalStorage } from '@zola-helpers/client';
import { PHOTO_PREVIEW_WALKTHROUGH_TRIGGERED } from '../constants';
import { STEPS } from '.';
import PreviewPhotoWalkthroughTooltip from './PreviewPhotoWalkthroughTooltip';

const PreviewPhotoWalkthrough = ({
  handleWalkthroughAddPhotoClick,
  setShowPreviewPhotoWalkthrough,
}: {
  handleWalkthroughAddPhotoClick: () => void;
  setShowPreviewPhotoWalkthrough: (value: boolean) => void;
}): JSX.Element => {
  const handleJoyrideCallback = (data: CallBackProps) => {
    if (data.type === 'tour:end') {
      setShowPreviewPhotoWalkthrough(false);
      // eslint-disable-next-line no-unused-expressions
      getLocalStorage(PHOTO_PREVIEW_WALKTHROUGH_TRIGGERED) === null &&
        setLocalStorage(PHOTO_PREVIEW_WALKTHROUGH_TRIGGERED, 'true');
    }
  };

  return (
    <Joyride
      steps={STEPS}
      callback={handleJoyrideCallback}
      disableScrolling
      tooltipComponent={({ children, ...props }) =>
        React.createElement(
          PreviewPhotoWalkthroughTooltip,
          {
            ...props,
            tooltipProps: { ...props.tooltipProps },
            handleWalkthroughAddPhotoClick,
          },
          children
        )
      }
      floaterProps={{
        disableAnimation: true,
        placement: 'left',
      }}
    />
  );
};

export default PreviewPhotoWalkthrough;
